import { useDevMode } from '@plug-core/state'
import { ListGroup, ListRow, Switch } from '@ui'
import { ROUTES } from '@utils/routes'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const DeveloperSettings = () => {
  const { networks, activeNetwork, devEnabled, setDevModeEnabled } = useDevMode()

  const navigate = useNavigate()

  return (
    <div className="mb-3 flex flex-col gap-4">
      <ListGroup>
        <div role="listitem" className="flex min-h-[60px] items-center px-4 py-2.5">
          <Switch
            className="w-full"
            label="Test Mode"
            description="Applies to balances and app connections"
            checked={devEnabled}
            onCheckedChange={setDevModeEnabled}
          />
        </div>

        <ListRow
          primary="Network"
          secondary={networks[activeNetwork || '']?.name || 'Not Set'}
          chevron
          onClick={() => navigate(ROUTES.DEVELOPER_SETTINGS_NETWORKS)}
        />
      </ListGroup>
    </div>
  )
}

export default DeveloperSettings
